import {Routes, RouterModule} from '@angular/router';
import {ErrorPageComponent} from './error-page.component';

const routes:Routes = [
  {
    path: 'error-page',
    component : ErrorPageComponent
  }];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/error-page/error-page.routing.ts